export default "__VITE_ASSET__$R5ZxnjN__"